"use client"

import { getLangCode } from "@/src/utils/string/getLangCode"
import { useParams } from "next/navigation"

export function useLangCode() {
    const params = useParams<{ locale?: string | string[] }>()
    const locale = Array.isArray(params.locale) ? params.locale[0] : params.locale
    return getLangCode(locale ?? "en") || "en"
}
